export const markerSvg = 'data:image/svg+xml,' + encodeURIComponent(
`<svg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <filter id='a' width='22' height='22' x='0' y='0' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'>
          <feFlood flood-opacity='0' result='BackgroundImageFix'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset dy='1'/>
          <feGaussianBlur stdDeviation='1.5'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'/>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset dy='2'/>
          <feGaussianBlur stdDeviation='1'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/>
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset/>
          <feGaussianBlur stdDeviation='1'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0'/>
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow'/>
          <feBlend in='SourceGraphic' in2='effect3_dropShadow' result='shape'/>
        </filter>
      </defs>
      <path stroke='white' stroke-width='1' fill='rgb(66, 153, 225)' d='M12.2 3a7.2 7.2 0 00-1.8 14.2l1.8 1.8 1.8-1.8A7.2 7.2 0 0012.2 3z' style='filter:url(#a)'/>
      <path fill='#FFF' d='M12.2 15.8c-2 0-3.8-1-4.8-2.5 0-1.5 3.2-2.3 4.8-2.3 1.6 0 4.8.8 4.8 2.3a5.8 5.8 0 01-4.8 2.5zM12.2 4.6a2.4 2.4 0 110 4.8 2.4 2.4 0 010-4.8z'/>
  </svg>`
);

export const pinMarker = 'data:image/svg+xml,' + encodeURIComponent(
    `<svg data-dropdown='true' width='30' height='30' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <filter id='a' width='28' height='28' x='0' y='0' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'>
          <feFlood flood-opacity='0' result='BackgroundImageFix'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset dy='1'/>
          <feGaussianBlur stdDeviation='1.5'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'/>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset dy='2'/>
          <feGaussianBlur stdDeviation='1'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/>
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset/>
          <feGaussianBlur stdDeviation='1'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0'/>
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow'/>
          <feBlend in='SourceGraphic' in2='effect3_dropShadow' result='shape'/>
        </filter>
      </defs>
      <path fill='rgb(255, 81, 0)' d='M12 2a7 7 0 00-7 7c0 5.3 7 13 7 13s7-7.8 7-13a7 7 0 00-7-7z' stroke='white' stroke-width='1' style='filter:url(#a)'/>
      <path fill='#FFF' d='M12 11a2 2 0 110-4 2 2 0 010 4z'/>
  </svg>`
);

export function clusterIcon(size = { w: 30, h: 30 }) {
    return (
        'data:image/svg+xml,' +
        encodeURIComponent(`<svg data-fadein='true' width='${size.w}' height='${size.h}' viewBox='0 0 ${size.w} ${size.h}' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <filter id='a' width='${size.w - 2}' height='${size.h - 2}' x='0' y='0' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'>
          <feFlood flood-opacity='0' result='BackgroundImageFix'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset dy='1'/>
          <feGaussianBlur stdDeviation='1.5'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'/>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset dy='2'/>
          <feGaussianBlur stdDeviation='1'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/>
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset/>
          <feGaussianBlur stdDeviation='1'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0'/>
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow'/>
          <feBlend in='SourceGraphic' in2='effect3_dropShadow' result='shape'/>
        </filter>
      </defs>
      <circle id='circle' cx='${size.w / 2}' cy='${size.h / 2}' r='${size.w / 2 - 6}' stroke='white' stroke-width='2' fill='rgb(113, 113, 113)' style='filter:url(#a)' />
      </svg>`)
    );
}

export const batchMarker = 'data:image/svg+xml,' + encodeURIComponent(
    `<svg data-fadein='true' width='36' height='36' viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <filter id='a' width='34' height='34' x='0' y='0' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'>
          <feFlood flood-opacity='0' result='BackgroundImageFix'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset dy='1'/>
          <feGaussianBlur stdDeviation='1.5'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'/>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset dy='2'/>
          <feGaussianBlur stdDeviation='1'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/>
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset/>
          <feGaussianBlur stdDeviation='1'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0'/>
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow'/>
          <feBlend in='SourceGraphic' in2='effect3_dropShadow' result='shape'/>
        </filter>
      </defs>
      <g fill='none' fill-rule='evenodd'>
        <path fill='rgb(255, 81, 0)' stroke='white' stroke-width='1' style='filter:url(#a)' d='M15 4.5a10.5 10.5 0 101.2 21l.3-.1.1.3a6.5 6.5 0 109-9l-.2-.2v-.3l.1-1.2c0-5.8-4.7-10.5-10.5-10.5z' />
        <path fill='white' fill-rule='nonzero' d='M9 11h1v8H9zM11 11h1v8h-1zM20.4 11c.3 0 .6.3.6.6v6.8c0 .3-.3.6-.6.6h-6.8a.6.6 0 01-.6-.6v-6.8c0-.3.3-.6.6-.6zm-2 4L17 17.3l-.9-1.5L15 18h5l-1.6-3z' />
      </g>
  </svg>`
);
export const defaultMarker = 'data:image/svg+xml,' + encodeURIComponent(
    `<svg data-fadein='true' width='30' height='30' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <filter id='a' width='28' height='28' x='0' y='0' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'>
          <feFlood flood-opacity='0' result='BackgroundImageFix'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset dy='1'/>
          <feGaussianBlur stdDeviation='1.5'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'/>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset dy='2'/>
          <feGaussianBlur stdDeviation='1'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/>
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow'/>
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/>
          <feOffset/>
          <feGaussianBlur stdDeviation='1'/>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0'/>
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow'/>
          <feBlend in='SourceGraphic' in2='effect3_dropShadow' result='shape'/>
        </filter>
      </defs>
      <circle cx='12' cy='12' r='8' fill='rgb(255, 81, 0)' stroke='white' stroke-width='1' style='filter:url(#a)'/>
      <path fill='#FFF' d='M15.4 8c.3 0 .6.3.6.6v6.8c0 .3-.3.6-.6.6H8.6a.6.6 0 01-.6-.6V8.6c0-.3.3-.6.6-.6zm-2 4L12 14.3l-.8-1.5L10 15h5l-1.6-3z'/>
  </svg>
`);